<template>
  <div class="board-body">
    <template v-for="(part, index) in parts" :key="index">
      <span v-if="part.kind === 'text'" class="board-text">{{ part.text }}</span>
      <img
        v-else
        class="board-image"
        :src="urls[part.file] || ''"
        alt=""
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { loadBoardImage, splitBoardBody } from '@/utils/boardBody';

const props = defineProps<{ body: string }>();
const urls = ref<Record<string, string>>({});
const parts = computed(() => splitBoardBody(props.body || ''));

watch(parts, async (list) => {
  const next = { ...urls.value };
  await Promise.all(list.filter((part) => part.kind === 'image').map(async (part) => {
    if (part.kind !== 'image' || next[part.file]) return;
    try {
      next[part.file] = await loadBoardImage(part.file);
    } catch (error) {
      console.error('게시 이미지 조회 실패:', error);
    }
  }));
  urls.value = next;
}, { immediate: true });
</script>
